import React from "react";
import { Form, Row, Col, Typography, Button, Space, Radio } from 'antd';
import { CaretLeftOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const AppStep18 = ({ next, prev, handleFormData, values }) => {
    const delay = ms => new Promise(res => setTimeout(res, ms));
    const submitFormData = async (e) => {
        await delay(500);
        next();
    };
    return(
        <Form 
            name="step18"
            onChange={submitFormData}
        >
            <Title level={2}>Combien de temps êtes-vous prêt à consacrer à la préparation d'un repas ?</Title>
            <Form.Item 
                name="temppreprepas"
                defaultValue={values.temppreprepas}
                onChange={handleFormData("temppreprepas")}
                rules={[
                    {
                    required: true,
                    message: 'Choisissez s\'il vous plaît!',
                    },
            ]}>
                <section className="typicalday">
                <Radio.Group>
                    <div className="typicaldaydiv">
                        <input type="radio" id="control_01" name="select" value="<30min" />
                        <label className="bodytypelbl" htmlFor="control_01">
                                <Text strong>Moins de 30 minutes</Text>
                        </label>
                    </div>
                    <div className="typicaldaydiv">
                        <input type="radio" id="control_02" name="select" value="30-60min" />
                        <label htmlFor="control_02">
                                <Text strong>30-60 minutes</Text>
                        </label>
                    </div>
                    <div className="typicaldaydiv">
                        <input type="radio" id="control_03" name="select" value=">1h" />
                        <label htmlFor="control_03">
                                <Text strong>Plus d'une heure</Text>
                        </label>
                    </div>
                    </Radio.Group>
                </section>
            </Form.Item>

            <Row justify="start">
            <Col xs={{ span: 8 }} sm={{ span: 6 }} md={{ span: 4 }}>
                <Form.Item  className="steps-action">
                <Space style={{ width: '100%' }}>
                    <Button onClick={prev} icon={<CaretLeftOutlined />} />
                    {/* <Button type="primary" htmlType="submit">
                        Continue
                    </Button> */}
                </Space>
                </Form.Item>
            </Col>
            </Row>
        </Form>
    )
}
export default AppStep18;